import * as React from "react";

import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { Button } from "grommet";
import { localizePairs } from "./utils/LocalizationStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const SignInButton = () => {
    const { instance } = useMsal();
    const [loading, setLoading] = React.useState(false);
    const handleLogin = () => {
        setLoading(true);
        instance.loginRedirect({ ...loginRequest, tokenQueryParameters: { context: DefaultOrganization }, extraQueryParameters: { context: DefaultOrganization } });
    };

    // React.useEffect(() => {
    //     let account = instance.getActiveAccount();
    //     if (!account) {
    //         instance.ssoSilent(loginRequest);
    //     }
    // }, []);

    return <Button onClick={() => handleLogin()} key="loginRedirect" label={"Continue"} icon={loading ? <FontAwesomeIcon icon={["fad", "loader"]} spin></FontAwesomeIcon> : <FontAwesomeIcon icon={["fad", "circle"]} beat></FontAwesomeIcon>}></Button>;
};
